"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventHandler = exports.EVENTS_KEY = void 0;
exports.EVENTS_KEY = '___settingsEvent';
function createEventHandler(initialData) {
    if (initialData === void 0) { initialData = {}; }
    var callbacks = {};
    var reset;
    var prevEventData = initialData[exports.EVENTS_KEY];
    return {
        notify: function (data) {
            if (data === void 0) { data = {}; }
            var eventData = data[exports.EVENTS_KEY];
            if (!eventData ||
                (prevEventData &&
                    eventData.payload &&
                    eventData.payload.id === prevEventData.payload.id)) {
                return;
            }
            prevEventData = eventData;
            if (eventData && eventData.event) {
                switch (eventData.event) {
                    case 'reset': {
                        if (reset) {
                            reset();
                        }
                        break;
                    }
                    default: {
                        if (callbacks[eventData.event]) {
                            callbacks[eventData.event](eventData.payload.value);
                        }
                    }
                }
            }
        },
        on: function (event, cb) {
            callbacks[event] = cb;
        },
        onReset: function (cb) {
            reset = cb;
        },
    };
}
exports.createEventHandler = createEventHandler;
//# sourceMappingURL=events.js.map